<template>
  <div class="pt-5" id="press-releases">
    <Title text="All Press Releases" class="my-5" />

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <div v-else>
      <div v-if="!noPressReleases">
        <div class="flex justify-between mb-4">
          <div class="flex flex-col">
            <Search @search="search" />
            <p v-if="noFilteredPressReleases" class="mt-2">No press releases</p>
          </div>

          <div>
            <p v-if="!noFilteredPressReleases" class="my-auto mb-2 text-sm">
              Page {{ pageNumber }}
            </p>
            <DownloadAll
              v-if="!noFilteredPressReleases"
              :data="directory.pressReleases"
              @downloadAll="downloadAll"
            />
          </div>
        </div>

        <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
          <div v-for="file in limitPressReleases" :key="file.id">
            <PressRelease
              data-aos="fade-in"
              data-aos-easing="ease-in-out"
              data-aos-duration="500"
              :featured="file.featured"
              :header="file.header"
              :date="file.date"
              :identifier="file.id"
            />
          </div>
        </div>
      </div>
      <p v-else>No press releases</p>
      <ExtraPages :num="pages" @handleClick="changePageNum" />
      <LineBreak class="mt-5" />
    </div>
  </div>
</template>

<script>
import PressRelease from "./PressRelease";
import Title from "../Title";
import DownloadAll from "../../DownloadAll.vue";
import LineBreak from "../../LineBreak.vue";
import Search from "../../Search.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import { mapGetters } from "vuex";
import initData from "../../../mixins/initData";
import loader from "../../../mixins/loader";
import ExtraPages from "../../ExtraPages.vue";
import { itemsPerPage, numberOfPages } from "../../../utils/itemsPerPage";

export default {
  name: "PressReleases",
  mixins: [initData, loader],

  data() {
    return {
      searchInput: "",
      max: 21,
      pageNumber: 1,
    };
  },

  components: {
    PressRelease,
    Title,
    DownloadAll,
    LineBreak,
    Search,
    LoadingSpinner,
    ExtraPages,
  },

  computed: {
    ...mapGetters(["directory", "pressReleasesID"]),

    filterPressReleases() {
      return this.directory.pressReleases.filter((file) => {
        const { header } = file;
        return header.toLowerCase().includes(this.searchInput.toLowerCase());
      });
    },

    limitPressReleases() {
      return itemsPerPage(this.filterPressReleases, this.max, this.pageNumber);
    },

    noPressReleases() {
      return this.directory.pressReleases.length === 0;
    },

    noFilteredPressReleases() {
      return this.filterPressReleases.length === 0;
    },

    pages() {
      return numberOfPages(this.filterPressReleases, this.max);
    },
  },

  methods: {
    search(text) {
      this.pageNumber = 1;
      this.searchInput = text;
    },

    changePageNum(index) {
      this.pageNumber = index;
    },

    async downloadAll(data) {
      await this.load(data(), "Downloading press releases");
    },
  },

  async created() {
    if (this.noPressReleases) {
      await this.load(
        this.initData(this.pressReleasesID),
        "Loading press releases",
      );
    }
  },
};
</script>
